export const TestId = {
  root: 'UserProfileButton',
  avatar: 'UserProfileButton.avatar',
}
